class ComponentBackgroundImage extends Theme.Component {

  connectedCallback() {
    this.intersectionObserver((entry, observer) => {
      const url = this.getOptimizedImageUrl();
      this.setBackgroundImage(url);
      observer.unobserve(this);
    }, { rootMargin: "200px" });
  }

  setBackgroundImage(url) {
    const element = this.parentElement;
    const position = this.dataset.position;

    element.style.backgroundImage = `url("${url}")`;
    element.style.backgroundSize = "cover";
    element.style.backgroundRepeat = "no-repeat";
    element.style.backgroundPosition = position;
  }

  getOptimizedImageUrl() {
    const url = new URL(this.getAttribute("src"), location.origin);
    const resolution = window.devicePixelRatio || 1;
    const width = Math.round(window.innerWidth * resolution);

    url.searchParams.set("width", width);

    return url.toString();
  }
}

customElements.define("component-background-image", ComponentBackgroundImage);
